/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'client-log-filters';

export const clientLogFilterBreadcrumbTitle = `${prefix}.clientLogFilterBreadcrumbTitle`;

export const ENGLISH = {
    [clientLogFilterBreadcrumbTitle]: 'Client Log Filter',
};
